// utils/globalShortcuts.js
export const setupGlobalShortcuts = (navigate) => {
  const handleKeyDown = (event) => {
    const isCtrlOrCmd = event.ctrlKey || event.metaKey;
    const isShift = event.shiftKey;
    const key = event.key?.toLowerCase();

    if (isCtrlOrCmd && isShift && (key === 'r' || key === 'f5')) {
      event.preventDefault();

      localStorage.clear();
      sessionStorage.clear();

      const { pathname } = window.location;
      const shouldGoHome =
        /\/[^/]+\/step-?\d+/.test(pathname) ||
        /QuoteResults/.test(pathname) ||
        pathname === '/quoteSelection';

      if (shouldGoHome) {
        navigate('/');
      } else {
        window.location.reload();
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
};
